<template>
  <div class="autosuggest-results-list">
    <div v-for="group in filteredData" :key="group" class="result-list-group">
      <div v-if="data[group].length && groupNames[group]" class="result-list-group__result-inner">
        <p :class="`result-list-group__label dea-heading--upper__m dea-${groupColor}`">{{ groupNames[group] }}</p>
        <ul class="result-list-group__suggestion-list">
          <li v-for="item in data[group]" :key="item.channel">
            <div class="result-list-group__autosuggest-result" @mousedown="openLink(item.href)">
              <!-- eslint-disable-next-line vue/no-v-html -->
              <span v-html="item.resultString"></span>
            </div>
          </li>
        </ul>
      </div>
      <hr v-if="data[group].length && groupNames[group]" class="dea-autosuggest__separator small-line--grey" />
    </div>
  </div>
</template>

<script>
export default {
  name: "AutosuggestListResults",

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    groupColor: {
      type: String,
      default: "",
    },
    groupNames: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    filteredData() {
      const groupNamesArray = Object.keys(this.groupNames || {});
      const dataToFilter = Object.keys(this.data);

      if (groupNamesArray.length === 0) {
        return dataToFilter;
      }

      const groupNamesFiltered = groupNamesArray.filter(el => dataToFilter.indexOf(el) > -1);
      const dataFilteredIn = dataToFilter.filter(el => groupNamesFiltered.indexOf(el) > -1);
      const dataFilteredOut = dataToFilter.filter(el => groupNamesFiltered.indexOf(el) < 0);

      dataFilteredIn.sort((a, b) => groupNamesFiltered.indexOf(a) - groupNamesFiltered.indexOf(b));

      return [...dataFilteredIn, ...dataFilteredOut];
    },
  },
  methods: {
    openLink(link) {
      if (!link) return;

      let url;
      let target = "_self";

      try {
        url = new URL(link);
      } catch (error) {
        console.log(error);
      }

      if (url && url.hostname !== window.location.hostname) {
        target = "_blank";
      }

      window.open(link, target);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$autosuggest-h: 360px;

.autosuggest-results-list {
  padding: $space-base;

  .result-list-group {
    &__result-inner {
      max-height: $autosuggest-h;
      overflow-y: auto;
    }

    &__label {
      margin-bottom: $space-base;
    }

    &__suggestion-list {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: $space-base;
      }
    }

    &__autosuggest-result {
      cursor: pointer;
    }
  }
}
</style>
